import { Pagination } from '@/entities/catalog-page/Pagination/ui/Pagination.jsx'
import './ui/Pagination.scss'
export default Pagination
